/*
=========================================================
* Otis Kit PRO - v2.0.2
=========================================================

* Product Page: https://material-ui.com/store/items/otis-kit-pro-material-kit-react/
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useRef } from 'react';

// rellax
import Rellax from 'rellax';

// typed-js
import * as Typed from 'typed.js';

// @mui material components
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';

// Otis Kit PRO components
import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';

// Otis Kit PRO examples
import Defaultnavbarr from 'examples/Navbars/DefaultNavbar';

// About Us page sections

// Routes
import routes from 'routes';
import footerRoutes from 'footer.routes';

// Images
import bgImage from 'assets/images/fondo4.png';
import TestimonialsTwo from 'layouts/sections/page-sections/testimonials/components/TestimonialsTwo';
import BlogCard2 from './sections/BlogCard2';
import FeaturesTwo from 'layouts/sections/page-sections/featuers/components/FeaturesTwo';
import WorkWithUs from 'layouts/sections/page-sections/work-with-us';
import Teamnew from './sections/teamm';
import SimpleFooter from 'examples/Footers/SimpleFooter';
import AnimatedWrapper from 'components/animation/animatedWrapper';
import ContactUsnew from 'layouts/sections/input-areas/contact-sections/components/ContactUsTwo/index2';
import Carrusel from 'assets/theme/components/carrusel'; // Desde el archivo actual

function AboutUs() {
  const headerRef = useRef(null);
  const typedJSRef = useRef(null);

  // Setting up rellax
  useEffect(() => {
    const parallax = new Rellax(headerRef.current, {
      speed: -6,
    });

    return () => parallax.destroy();
  }, []);

  // Setting up typedJS
  useEffect(() => {
    const typedJS = new Typed(typedJSRef.current, {
      strings: [
        'Desarrollo de tecnologías',
        'Diseño de soluciones',
        'Arquitectura de software',
        'I+D+i',
        'Cloud native',
      ],
      typeSpeed: 90,
      backSpeed: 90,
      backDelay: 200,
      startDelay: 500,
      loop: true,
      showCursor: false,
      cursorChar: '',
    });

    return () => typedJS.destroy();
  }, []);

  return (
    <>
      <Defaultnavbarr
        routes={routes}
        // action={{
        //   type: "external",
        //   route: "https://material-ui.com/store/items/otis-kit-pro-material-kit-react/",
        //   label: "buy now",
        //   color: "default",
        // }}
        transparent
        light
      />
      <MKBox
        ref={headerRef}
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',

          width: '100%',
          minHeight: '75vh',
          display: 'grid',
          placeItems: 'center',
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={8}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{ mx: 'auto', textAlign: 'center' }}
          >
            <MKTypography
              variant="h1"
              color="white"
              sx={({ breakpoints, typography: { size } }) => ({
                textAlign: 'center',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexWrap: 'wrap',
                lineHeight: 1.2,
                [breakpoints.down('md')]: {
                  fontSize: size['2xl'],
                  flexDirection: 'column',
                },
              })}
            >
              <span style={{ whiteSpace: 'pre-wrap' }}>Crecemos contigo a través de&nbsp;</span>
              <span
                ref={typedJSRef}
                style={{
                  color: '#1976d2',
                  fontWeight: 'bold',
                  display: 'inline-block',
                  minHeight: '2.5rem',
                  maxWidth: '100%',
                  wordBreak: 'break-word',
                }}
              />
            </MKTypography>

            <MKTypography variant="body1" color="white" opacity={0.8} mt={1} mb={3}>
              Generamos capacidades tecnológicas al interior de tu organización para impulsar su
              transformación digital.
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <AnimatedWrapper>
        <Card
          sx={{
            p: 2,
            mx: { xs: 2, lg: 3 },
            mt: -8,
            mb: 4,
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        >
          <FeaturesTwo />
          <BlogCard2 />

          <TestimonialsTwo />
          <Teamnew />
          <Carrusel />
          {/* <AboutContactUs /> */}
          <WorkWithUs />
          <ContactUsnew />
        </Card>
      </AnimatedWrapper>
      <MKBox pt={6} px={1} mt={6}>
        <SimpleFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default AboutUs;
